import { useSubmitJob } from "@/api/queries";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Callout, ErrorNote } from "@/components/ui/panel";

/**
 * Shown right after a requeue or re-enrich sends a row back into the pipeline — the
 * moment a reviewer most needs "now what" answered, since nothing on Review or
 * Questions otherwise triggers a run. `stage` is the status the row landed on
 * (review.requeue's return value).
 */
export function PipelineNudge({ stage, onDismiss }: { stage: string; onDismiss: () => void }) {
  const submit = useSubmitJob();
  return (
    <div className="space-y-1.5">
      <Callout tone="attention" className="flex flex-wrap items-center justify-between gap-2">
        <span>
          Sent to <Badge value={stage} /> — returns here after the next pipeline run.
        </span>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            size="sm"
            variant="primary"
            disabled={submit.isPending}
            onClick={() => submit.mutate("pipeline", { onSuccess: onDismiss })}
          >
            {submit.isPending ? "Queuing…" : "Run pipeline"}
          </Button>
          <Button size="sm" variant="ghost" onClick={onDismiss}>
            Dismiss
          </Button>
        </div>
      </Callout>
      <ErrorNote error={submit.error} />
    </div>
  );
}
